import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';

@Component({
  selector: 'app-account-info-presentation',
  templateUrl: './account-info-presentation.component.html',
  styleUrls: ['./account-info-presentation.component.scss']
})
export class AccountInfoPresentationComponent implements OnInit {

  @Input() accountName = "";
  @Input() accountNumber: string|number = ""
  @Input() bankName = ""
  @Input() changable = false;
  @Output() changeEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  emitChange(){
    this.changeEvent.emit();
  }

  getInitials(beneficiaryName: string) {
		return StringHelper.getInitials(beneficiaryName);
	}

}
